/* ============================================================
   The Niva Store — Custom JS
   ============================================================ */

/* Fix #2d — Touch image swap on product cards
   Toggles 'touch-hover' class on tap so alternate product
   images are visible on touchscreen devices.
   ---------------------------------------------------------- */
/* ----------------------------------------------------------
   Stats bar — count-up animation
   Counts each .stats-bar__number from 0 to its data-count-to
   value when scrolled into view. Fires once per page load.
   Respects prefers-reduced-motion (shows final value instantly).
   ---------------------------------------------------------- */
(function () {
  var counters = document.querySelectorAll('.stats-bar__number[data-count-to]');
  if (!counters.length) return;

  function easeOutQuad(t) { return t * (2 - t); }

  function decimalsIn(str) {
    var dot = str.indexOf('.');
    return dot === -1 ? 0 : str.length - dot - 1;
  }

  function animateCounter(el) {
    var raw    = el.dataset.countTo;
    var target = parseFloat(raw);
    var suffix = el.dataset.suffix || '';
    var dec    = decimalsIn(raw);
    var duration = 1600;
    var startTime = null;

    el.textContent = (0).toFixed(dec) + suffix;

    function step(now) {
      if (!startTime) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      var value = easeOutQuad(progress) * target;
      el.textContent = value.toFixed(dec) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  /* Respect reduced-motion — show final values immediately */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(function (el) { observer.observe(el); });
})();

/* ----------------------------------------------------------
   Collection description — price pill
   Finds "Starting at ₹X" (with optional trailing emoji/spaces)
   and wraps it in a styled pill on its own line.
   ---------------------------------------------------------- */
(function () {
  var desc = document.querySelector('.collection-hero__description');
  if (!desc) return;

  var html = desc.innerHTML;
  // Match "Starting at ₹NNN" optionally followed by spaces and emojis
  html = html.replace(
    /(Starting at\s*₹[\d,]+(?:\s*[✨\s]*)?)/g,
    '<br><span class="collection-desc__price">$1</span>'
  );
  desc.innerHTML = html;
})();

/* ---------------------------------------------------------- */

if ('ontouchstart' in window) {
  document.addEventListener('touchstart', function (e) {
    const card = e.target.closest('.card-wrapper');
    if (!card) return;

    document.querySelectorAll('.card-wrapper.touch-hover').forEach(function (el) {
      if (el !== card) el.classList.remove('touch-hover');
    });
    card.classList.toggle('touch-hover');
  }, { passive: true });
}
